import { capitalize } from 'Data/format.js'

export function getStatus(status) {
  return status
    .split('_')
    .map(el => capitalize(el))
    .join(' ')
}
